import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDf = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 40.000000 40.000000",
	preserveAspectRatio: "xMidYMid meet",
	width: "1em",
	height: "1em",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		transform: "translate(0.000000,40.000000) scale(0.100000,-0.100000)",
		fill: "currentColor",
		stroke: "none",
		children: [
			/* @__PURE__ */ _jsx("path", { d: "M65 391 c-11 -5 -29 -19 -40 -31 -18 -20 -20 -36 -20 -161 0 -138 0 -139 28 -166 27 -28 28 -28 167 -28 139 0 140 0 167 28 28 27 28 28 28 167 0 139 0 140 -28 167 -27 27 -30 28 -155 30 -70 2 -136 -1 -147 -6z m125 -90 c0 -21 3 -59 6 -85 6 -38 4 -46 -10 -46 -9 0 -16 7 -16 15 0 8 -9 15 -20 15 -11 0 -20 -7 -20 -15 0 -8 -7 -15 -16 -15 -13 0 -15 10 -9 68 10 99 11 102 51 102 33 0 34 -1 34 -39z m110 -31 c0 -56 -3 -70 -15 -70 -12 0 -15 13 -15 55 0 30 -4 55 -10 55 -5 0 -10 -25 -10 -55 0 -48 -2 -55 -20 -55 -18 0 -20 7 -20 70 l0 70 45 0 45 0 0 -70z m-191 -141 c-16 -5 -18 -7 -6 -8 21 -1 23 -21 2 -21 -8 0 -15 -5 -15 -11 0 -6 7 -9 15 -5 9 3 15 0 15 -10 0 -10 -8 -14 -22 -12 -18 2 -24 11 -26 38 -4 41 21 68 46 48 12 -11 11 -14 -9 -19z m209 19 c14 -14 16 -57 3 -76 -5 -8 -17 -12 -27 -10 -23 4 -32 62 -13 84 14 17 21 18 37 2z m-128 -43 c0 -41 -2 -45 -25 -45 -23 0 -25 4 -25 45 0 41 2 45 25 45 23 0 25 -4 25 -45z m68 17 c2 -13 -3 -25 -12 -28 -9 -3 -16 -12 -16 -20 0 -8 -7 -14 -15 -14 -11 0 -15 12 -15 46 0 44 1 45 28 42 19 -2 28 -9 30 -26z" }),
			/* @__PURE__ */ _jsx("path", { d: "M147 276 c-5 -21 -6 -41 -3 -44 12 -11 17 7 14 44 l-3 39 -8 -39z" }),
			/* @__PURE__ */ _jsx("path", { d: "M290 105 c0 -14 5 -25 10 -25 6 0 10 11 10 25 0 14 -4 25 -10 25 -5 0 -10 -11 -10 -25z" })
		]
	})
});
export default SvgDf;
